<template>
  <div class="bc-white padding-20">
    <div class="display-flex jc-space-between ai-center mb-20">
      <b class="fs-18">检查表库</b>
      <el-button type="primary" icon="el-icon-plus" size="small" @click="addCheckForm">添加检查表</el-button>
    </div>
    <div class="display-flex jc-space-between ai-flex-start">
      <el-form :inline="true" size="small" v-model="searchForm">
        <el-form-item label="">
          <el-select
            class="width-140"
            clearable
            placeholder="检查表类型"
            v-model="searchForm.checklistTypeId">
            <el-option
              v-for="item in option.type"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="">
          <el-input
            placeholder="请输入关键字搜索"
            clearable
            @keyup.enter.native="searchChecklists"
            v-model="searchForm.fuzzy"
          ></el-input>
        </el-form-item>
        <el-form-item label="">
          <el-button type="primary" icon="el-icon-search" @click="searchChecklists">查询</el-button>
          <el-button icon="el-icon-refresh-left" @click="resetSearch">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-table
        border
        :data="tableData">
        <el-table-column
          prop="name"
          label="检查表名称">
        </el-table-column>
        <el-table-column
          prop="checklistTypeName"
          label="检查表类型">
        </el-table-column>
        <el-table-column
          prop="description"
          label="检查表描述">
        </el-table-column>
        <el-table-column
          align="center"
          prop="createByName"
          label="创建人">
        </el-table-column>
        <el-table-column
          prop="updateAt"
          label="最后修改时间">
        </el-table-column>
        <el-table-column
          fixed="right"
          label="操作">
          <template  #default="{row}">
            <!-- <el-button
              @click="show(row.id)"
              type="text"
              class="color-primary">详情</el-button>
            <el-divider direction="vertical"></el-divider> -->
            <el-button
              @click="editCheckForm(row)"
              type="text"
              class="color-primary">编辑</el-button>
            <el-divider direction="vertical"></el-divider>
            <el-button
              @click="openCheckStandard(row.id)"
              type="text"
              class="color-danger">检查标准</el-button>
            <el-divider direction="vertical"></el-divider>
            <el-button
              @click="delCheckForm(row.id)"
              type="text"
              class="color-danger">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    <div class="display-flex fd-row-reverse mt-20">
        <!-- 表格数据的分页的功能 -->
        <el-pagination
          hide-on-single-page
          @current-change="(val) => {searchForm.page = val}"
          :current-page="searchForm.page"
          :page-size="searchForm.limit"
          background
          layout="total, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
    </div>
    <el-dialog
      v-if="checkFormDialog.show"
      :title="checkFormDialog.title"
      :visible.sync="checkFormDialog.show"
      width="30%">
      <el-form class="diy-top-form" :model="checkFormDialog.form" ref="checkForm" label-position="top" size="small">
          <el-form-item label="检查表名称" prop="name" :rules="{required: true, message: '请输入检查表名称', trigger: 'blur'}">
            <el-input v-model="checkFormDialog.form.name" placeholder="请输入检查表名称"></el-input>
          </el-form-item>
          <el-form-item label="检查表类型">
            <el-select
              class="width-percent-100"
              clearable
              placeholder="检查表类型"
              v-model="checkFormDialog.form.checklistTypeId">
              <el-option
                v-for="item in option.type"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="检查表描述" prop="description">
            <el-input class="width-percent-100" v-model="checkFormDialog.form.description" placeholder="请输入检查表描述"></el-input>
          </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button size="small" type="primary" @click="submitCheckForm">确 定</el-button>
        <el-button size="small" @click="checkFormDialog.show = false">取 消</el-button>
      </span>
    </el-dialog>
    <el-dialog
      v-if="checkStandardDialog.show"
        :title="checkStandardDialog.title"
        :visible.sync="checkStandardDialog.show"
        :before-close="hideClose"
        width="1378px"
        append-to-body>
        <el-form class="diy-top-form" :model="checkStandardDialog.form" ref="checkStandardForm" label-position="top" size="small">
          <el-form-item>
          <div class="display-flex checkStandard">
             <div class="left">
               <div class="left-title display-flex jc-space-between mb-10">
                  <span>选择检查项目</span>
                  <el-button icon="el-icon-plus" type="text" @click="addStandard">添加</el-button>
               </div>
               <div class="scrollbar-y">
                  <el-scrollbar style="height: 545px">
                    <div class="container" v-infinite-scroll="getDirList" :infinite-scroll-disabled="noMore">
                      <div
                        :class="{active: selCheckItem.id === item.id}"
                        class="item display-flex jc-space-between ai-center"
                        v-for="(item, index) in checkStandardDialog.form.checkList"
                        :key="item.id"
                        @click="handleClick(item)">
                        <span class="mt-0 fs-14">{{index + 1}}.{{ item.name }}</span>
                        <span>
                          <i @click="editStandard(item)" class="el-icon-edit-outline color-primary"></i>
                          <el-divider direction="vertical"></el-divider>
                          <i @click="delStandard(item.id)" class="el-icon-remove-outline color-danger"></i>
                        </span>
                      </div>
                    </div>
                    <p class="ta-center fs-14 color-info" v-if="noMore">没有更多了</p>
                    <p class="ta-center fs-14 color-info" v-else>加载中</p>
                  </el-scrollbar>
              </div>
            </div>
             <div class="right">
                <div class="display-flex jc-space-between ai-center">
                   <div class="flex-left">
                      <b class="mr-10 fs-18">检查标准</b>
                      <span>当前检查项目: {{ selCheckItem.name || '全部' }}</span>
                   </div>
                   <div class="flex-right">
                      <el-button type="text" icon="el-icon-upload2" @click="openImport">从检查标准库导入</el-button>
                      <el-button type="text" icon="el-icon-plus" @click="addCheckStandrad">添加检查标准</el-button>
                   </div>
                </div>
                    <el-table
                      class="mt-20"
                      size="small"
                      height="545px"
                      border
                      key="1"
                      v-el-table-infinite-scroll="getItemList"
                      :infinite-scroll-disabled="isNext"
                      :data="checkStandardDialog.form.checkStandardList">
                  <el-table-column
                    width="66"
                    align="center"
                    type="index"
                    label="序号">
                  </el-table-column>
                  <el-table-column
                    prop="content"
                    label="检查标准(合规要求)">
                    <template #default="{row}">
                      <div v-html="replaceWhite(row.content)"></div>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="basisName"
                    label="检查依据">
                    <template #default="{row}">
                      <div style="font-weight:bold">依据文件名称:<span style="font-weight: normal">{{ row.basisName }}</span></div>
                      <div style="font-weight:bold">依据文件编号:<span style="font-weight: normal">{{ row.basisNo }}</span></div>
                      <div style="font-weight:bold">依据条目号及其原文:<span style="font-weight: normal">{{ row.basisContent }}</span></div>
                    </template>
                  </el-table-column>
                  <el-table-column
                    width="114"
                    prop="email"
                    label="操作">
                    <template #default="{row}">
                      <el-button size="mini" icon="el-icon-edit-outline" type="text" @click="editCheckStandrad(row)"></el-button>
                      <el-divider direction="vertical"></el-divider>
                      <el-button size="mini" icon="el-icon-remove-outline" type="text" class="color-danger" @click="delCheckStandrad(row)"></el-button>
                    </template>
                  </el-table-column>
                     </el-table>
             </div>
          </div>
        </el-form-item>
        </el-form>
        <el-dialog
          width="20%"
          :title="checkProjectDialog.title"
          :visible.sync="checkProjectDialog.show"
          append-to-body>
          <el-form class="diy-top-form" :model="checkProjectDialog.form" ref="checkProjectForm" label-position="top" size="small">
             <el-form-item label="检查项目名称" :rules="{require: true, message:'请输入检查项目名称', trigger:'blur'}">
                <el-input v-model="checkProjectDialog.form.name" placeholder="请输入检查项目名称"></el-input>
             </el-form-item>
          </el-form>
          <span slot="footer">
          <el-button size="small" type="primary" @click="submitStandard">确 定</el-button>
          <el-button size="small" @click="checkProjectDialog.show = false">取 消</el-button>
        </span>
        </el-dialog>
        <el-dialog
          v-if="checkItemDialog.show"
          :title="checkItemDialog.title"
          :visible.sync="checkItemDialog.show"
          append-to-body
          width="656px">
          <el-form class="diy-top-form" :model="checkItemDialog.form" ref="positionForm" label-position="top" size="small">
            <div class="display-flex ai-center" style="line-height: 40px;">
              <b style="font-size: 16px; font-weight: bolder">基本信息</b>
            </div>
            <el-form-item label="所属分类" prop="checklistDirectoryId" :rules="{required: true, message: '请选择所属分类（单选),选到任意一级', trigger: 'blur'}">
              <el-cascader
                clearable
                placeholder="请选择所属分类（单选），选到任意一级"
                class="width-percent-100"
                v-model="checkItemDialog.form.checklistDirectoryId"
                :options="checkStandardDialog.form.checkList"
                :props="{ expandTrigger: 'hover', emitPath: false, checkStrictly: true, label: 'name', value: 'id' }"></el-cascader>
            </el-form-item>
            <el-form-item label="检查标准 (合规要求)" prop="content" :rules="{required: true, message: '请输入检查标准 (合规要求)', trigger: 'change'}">
              <el-input type="textarea" v-model="checkItemDialog.form.content" placeholder="请输入检查标准 (合规要求)"></el-input>
            </el-form-item>
            <div class="display-flex ai-center" style="line-height: 40px;">
              <b style="font-size: 16px; font-weight: bolder">检查依据</b>
            </div>
            <el-form-item label="依据文件名称">
              <el-input v-model="checkItemDialog.form.basisName" placeholder="请输入依据文件名称"></el-input>
            </el-form-item>
            <el-form-item label="依据文件编号">
              <el-input v-model="checkItemDialog.form.basisNo" placeholder="请输入依据文件编号"></el-input>
            </el-form-item>
            <el-form-item label="依据条目号及原文">
              <el-input v-model="checkItemDialog.form.basisContent" placeholder="依据条目号及原文"></el-input>
            </el-form-item>
          </el-form>
          <span slot="footer">
            <el-button size="small" type="primary" @click="submitCheckItem">确 定</el-button>
            <el-button size="small" @click="checkItemDialog.show = false">取 消</el-button>
          </span>
        </el-dialog>
        <el-dialog
          v-if="importDialog.show"
          title="批量导入"
          :visible.sync="importDialog.show"
          width="1300px" append-to-body>
          <div class="display-flex height-percent-100" style="border: 1px solid">
            <div class="width-260 padding-20 bc-white" style="border-right: 1px solid">
              <div class="display-flex  jc-space-between mb-20">
                <span class="fs-18">检查标准分类项目</span>
              </div>
              <el-input
                clearable
                placeholder="关键词查询"
                v-model="filterText">
              </el-input>
              <div class="scrollbar-y">
                <el-scrollbar style="height: 580px; overflow-y: auto;">
                 <el-tree
                  ref="tree"
                  node-key="id"
                  highlight-current
                  default-expand-all
                  :expand-on-click-node="false"
                  :data="directoryTree"
                  :props="defaultProps"
                  :filter-node-method="filterNode"
                  @node-click="handleNodeClick">
                  <span class="custom-tree-node" slot-scope="{ node }">
                    <span>{{ node.label }}</span>
                  </span>
              </el-tree>
              </el-scrollbar>
              </div>
            </div>
            <div class="bc-white flex-1" style="overflow: auto">
              <div style="line-height: 57px">
                <b class="ml-20 mr-16">检查标准列表</b>
                <span>已选分类: {{ selTreeItem.name || '全部' }}</span>
              </div>
              <el-divider ></el-divider>
              <div class="padding-20">
                <div class="display-flex ai-center jc-space-between">
                  <div>
                    <el-input  v-model="treeSearchForm.fuzzy" size="small" class="width-220 mr-20" placeholder="请输入关键词搜索" clearable ></el-input>
                    <el-button size="small" type="primary" icon="el-icon-search" @click="searchTreeData">查询</el-button>
                    <el-button size="small" icon="el-icon-refresh-left" @click="resetTreeData">重置</el-button>
                  </div>
                </div>
                <el-table
                  class="mt-20"
                  size="small"
                  height="545px"
                  v-el-table-infinite-scroll="getTreeData"
                  :infinite-scroll-disabled="scrollMore"
                  border
                  :data="treeData">
                  <el-table-column
                    width="247"
                    align="center"
                    label="所属分类">
                    <template #default="{row}">
                      {{ row.checkStandardNameList.join('>')}}
                    </template>
                  </el-table-column>
                  <el-table-column
                    align="center"
                    prop="content"
                    label="检查标准(合规要求)">
                    <template #default="{row}">
                      <div v-html="replaceWhite(row.content)"></div>
                    </template>
                  </el-table-column>
                  <el-table-column
                    align="center"
                    prop="basisName"
                    label="检查依据">
                    <template #default="{row}">
                      <div style="font-weight: bold;">依据文件名称: <span style="font-weight: normal;">{{ row.basisName }}</span></div>
                      <div style="font-weight: bold;">依据文件编号: <span style="font-weight: normal;">{{ row.basisNo }}</span></div>
                      <div style="font-weight: bold;">依据条目号及其原文: <span style="font-weight: normal;">{{ row.basisContent }}</span></div>
                    </template>
                  </el-table-column>
                  <el-table-column
                    width="60"
                    align="center"
                    prop="email"
                    label="操作">
                    <template #default="{row}">
                      <el-checkbox v-model="row.selected"></el-checkbox>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </div>
          </div>
          <span slot="footer">
            <el-button size="small" type="primary" @click="submitImport">确 定</el-button>
            <el-button size="small" @click="importDialog.show = false">取 消</el-button>
          </span>
        </el-dialog>
      </el-dialog>
  </div>
</template>

<script>
import _ from 'lodash';
import ElTableInfiniteScroll from 'el-table-infinite-scroll'
export default {
  name: 'CheckTable',
  components: { },
  data () {
    return {
      filterText: '',
      isNext: false,
      noMore: false,
      scrollMore: false,
      searchForm: {
        fuzzy: '',
        checklistTypeId: '',
        page: 1,
        limit: 10
      },
      checkSearchForm: {
        checklistId: '',
        page: 1,
        limit: 10,
        total: 10
      },
      standSearchForm: {
        checklistId: '',
        checklistDirectoryId: '',
        page: 1,
        limit: 10,
        total: 10
      },
      treeSearchForm: {
        fuzzy: '',
        checkStandardId: '',
        pageNum: 1,
        pageSize: 10,
        currentTotal: 10
      },
      option: {
        type: []
      },
      tableData: [],
      total: 0,
      checkFormDialog: {
        title: '',
        show: false,
        form: {
          id: '',
          name: '',
          description: '',
          checklistTypeId: ''
        }
      },
      checkProjectDialog: {
        title: '',
        show: false,
        form: {
          id: '',
          name: '',
          checklistId: '',
          sort: 1
        }
      },
      checkStandardDialog: {
        title: '添加检查标准',
        show: false,
        form: {
          checkList: [], // 检查项目列表
          checkStandardList: [] // 检查标准列表
        }
      },
      selCheckItem: {
      },
      selTreeItem: {
      },
      checkItemDialog: { // 标准列表dialog
        show: false,
        title: '',
        form: {
          id: '',
          checklistDirectoryId: '',
          content: '',
          basisName: '',
          basisNo: '',
          basisContent: '',
          checkMethod: '',
          sort: 1
        }
      },
      importDialog: { // 标准列表dialog
        show: false,
        title: '',
        form: {
          checkList: []
        }
      },
      directoryTree: [],
      defaultProps: {
        children: 'children',
        label: 'name'
      },
      treeData: []
    }
  },
  directives: {
    'el-table-infinite-scroll': ElTableInfiniteScroll
  },
  watch: {
    filterText (val) {
      this.$refs.tree.filter(val);
    },
    selCheckItem: {
      // 当被选项发生变化时, 发起检查标准的请求
      handler (newVal, oldVal) {
        this.standSearchForm.checklistDirectoryId = newVal.id || '';
        this.standSearchForm.page = 1;
        this.getItemList();
      },
      deep: true
    },
    selTreeItem: {
      handler (newVal) {
        this.treeSearchForm.checkStandardId = newVal.id || '';
        this.treeSearchForm.pageNum = 1;
        // 进行右侧列表的更新
        this.getTreeData();
      },
      deep: true,
      immediate: true
    }
  },
  computed: {},
  methods: {
    searchChecklists () {
      this.searchForm.page = 1
      this.getTableData()
    },
    resetSearch () {
      this.searchForm.fuzzy = ''
      this.searchForm.checklistTypeId = ''
      this.searchForm.page = 1
      this.getTableData()
    },
    replaceWhite (html) { // 处理富文本默认图片，视频大小
      let newContent = html.replace(/<video[^>]*>/gi, function (match, capture) {
        match = match.replace(/style="[^"]+"/gi, '').replace(/style='[^']+'/gi, '')
        match = match.replace(/width="[^"]+"/gi, '').replace(/width='[^']+'/gi, '')
        match = match.replace(/height="[^"]+"/gi, '').replace(/height='[^']+'/gi, '')
        return match
      }).replace(/<img[^>]*>/gi, function (match, capture) {
        match = match.replace(/style="[^"]+"/gi, '').replace(/style='[^']+'/gi, '')
        match = match.replace(/width="[^"]+"/gi, '').replace(/width='[^']+'/gi, '')
        match = match.replace(/height="[^"]+"/gi, '').replace(/height='[^']+'/gi, '')
        return match
      });
      newContent = newContent.replace(/style="[^"]+"/gi, function (match, capture) {
        match = match.replace(/width:[^;]+;/gi, 'max-width:100%;').replace(/width:[^;]+;/gi,
          'max-width:100%;')
        return match
      });
      newContent = newContent.replace(/<br[^>]*\/>/gi, '')
      newContent = newContent.replace(/<video/gi,
        '<video style="max-width:100%;height:auto;display:inline-block;margin:10rpx auto;"').replace(/<img/gi,
        '<img style="max-width:100%;height:auto;display:inline-block;margin:10rpx auto;"')
      return newContent
    },
    filterNode (value, data) {
      if (!value) return true;
      return data.name.indexOf(value) !== -1;
    },
    addCheckForm () {
      this.checkFormDialog = {
        title: '添加检查表',
        show: true,
        form: {
          id: '',
          name: '',
          description: '',
          checklistTypeId: ''
        }
      }
    },
    editCheckForm (row) {
      this.checkFormDialog = {
        title: '添加检查表',
        show: true,
        form: {
          id: row.id,
          name: row.name,
          description: row.description,
          checklistTypeId: row.checklistTypeId
        }
      }
    },
    delCheckForm (id) {
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$api.checkTable.delList([id]).then(res => {
          this.$message.success('删除成功')
          this.searchForm.page = 1
          this.getTableData()
        })
      }).catch(() => {});
    },
    submitCheckForm () {
      this.$refs.checkForm.validate(valid => {
        if (valid) {
          if (this.checkFormDialog.form.id) {
            this.$api.checkTable.updateList(this.checkFormDialog.form).then(res => {
              this.$message.success('编辑成功')
              this.checkFormDialog.show = false
              this.getTableData()
            })
          } else {
            this.$api.checkTable.saveList(this.checkFormDialog.form).then(res => {
              this.$message.success('添加成功')
              this.checkFormDialog.show = false
              this.getTableData()
            })
          }
        }
      })
    },
    openCheckStandard (id) {
      // 每次打开, 进行列表重置
      this.checkSearchForm.page = 1;
      this.standSearchForm.page = 1;
      this.checkStandardDialog.form.checkList = [];
      this.checkStandardDialog.form.checkStandardList = [];
      // 这边有问题, 只给左侧的查询条件进行了更新,并没有给右侧的查询条件进行更新
      this.checkSearchForm.checklistId = id;
      this.standSearchForm.checklistId = id;
      this.getDirList();
      this.getItemList();
      this.checkStandardDialog.show = true
      // this.getDirList();
    },
    addStandard () {
      this.checkProjectDialog = {
        title: '添加检查项目',
        show: true,
        form: {
          id: '',
          name: '',
          checklistId: this.checkSearchForm.checklistId,
          sort: 1
        }
      }
    },
    editStandard (item) {
      this.checkProjectDialog = {
        title: '编辑检查项目',
        show: true,
        form: {
          id: item.id,
          name: item.name,
          checklistId: this.checkSearchForm.checklistId,
          sort: 1
        }
      }
    },
    delStandard (id) {
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$api.checkTable.delDirList([id]).then(res => {
          this.$message.success('删除成功')
          this.checkSearchForm.page = 1;
          this.getDirList()
        })
      }).catch(() => {});
    },
    submitStandard () {
      console.log(this.checkProjectDialog.form);
      this.$refs.checkProjectForm.validate(valid => {
        if (valid) {
          if (this.checkProjectDialog.form.id) {
            this.$api.checkTable.updateDirList(this.checkProjectDialog.form).then(res => {
              this.$message.success('编辑成功')
              this.checkProjectDialog.show = false;
              this.checkSearchForm.page = 1;
              this.getDirList()
            })
          } else {
            this.$api.checkTable.saveDirList(this.checkProjectDialog.form).then(res => {
              this.$message.success('添加成功')
              this.checkProjectDialog.show = false;
              this.checkSearchForm.page = 1;
              this.getDirList()
            })
          }
        }
      })
    },
    addCheckStandrad () {
      this.checkItemDialog = {
        show: true,
        title: '添加检查标准',
        form: {
          id: '',
          content: '',
          checklistDirectoryId: this.selCheckItem.id,
          basisNo: '',
          basisName: '',
          basisContent: '',
          checkMethod: '1',
          sort: 1
        }
      }
    },
    editCheckStandrad (data) {
      this.checkItemDialog = {
        show: true,
        title: '编辑检查标准',
        form: {
          id: data.id,
          content: data.content,
          checklistDirectoryId: data.checklistDirectoryId,
          basisNo: data.basisNo,
          basisName: data.basisName,
          basisContent: data.basisContent,
          checkMethod: '1',
          sort: 1
        }
      }
    },
    delCheckStandrad (data) {
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$api.checkTable.delItemList([data.id]).then(res => {
          this.$message.success('删除成功')
          this.standSearchForm.page = 1
          this.getItemList()
        })
      }).catch(() => {});
    },
    // 提交检查标准
    submitCheckItem () {
      this.$refs.positionForm.validate(valid => {
        if (valid) {
          if (this.checkItemDialog.form.id) {
            this.$api.checkTable.updateItemList(this.checkItemDialog.form).then(res => {
              this.$message.success('编辑成功')
              this.checkItemDialog.show = false;
              this.standSearchForm.page = 1;
              this.getItemList()
            })
          } else {
            this.$api.checkTable.saveItemList(this.checkItemDialog.form).then(res => {
              this.$message.success('添加成功')
              this.checkItemDialog.show = false;
              this.standSearchForm.page = 1;
              this.getItemList()
            })
          }
        }
      })
    },
    // 提交导出
    submitImport () {
      const checkList = this.treeData.filter(v => v.selected).map(item => item.id);
      this.$api.checkTable.importByCheckStandard({
        checkStandardItemIdList: checkList,
        checklistDirectoryId: this.selCheckItem.id
      }).then(res => {
        this.$message.success('添加成功');
        this.importDialog.show = false;
        // 重置选择状态
        this.treeData.forEach(v => { v.selected = false });
        // 添加标准后, 默认page为1
        this.standSearchForm.page = 1;
        this.getItemList();
      })
    },
    getTableData: _.debounce(function () {
      this.$api.checkTable.getList({
        ...this.searchForm,
        pageNum: this.searchForm.page,
        pageSize: this.searchForm.limit
      }).then(res => {
        this.tableData = res.list;
        this.total = res.total
      })
    }, 500),
    getDirList: _.debounce(function () {
      const data = {
        checklistId: this.checkSearchForm.checklistId,
        pageNum: this.checkSearchForm.page,
        pageSize: this.checkSearchForm.limit
      }
      // this.noMore = false;
      // 这版也是可以用的, 但是因为判断加载条件写在前面,每个编辑,修改,删除处都需要加上this.checkSearchForm.total = this.checkSearchForm.limit 这句话,重置判断条件
      // if (this.checkSearchForm.total >= this.checkSearchForm.limit) {
      //   this.$api.checkTable.getDirList(data).then(res => {
      //     if (this.checkSearchForm.page === 1) {
      //       this.checkStandardDialog.form.checkList = []
      //     }
      //     this.checkStandardDialog.form.checkList = [...this.checkStandardDialog.form.checkList, ...res.list];
      //     this.checkSearchForm.total = res.list.length;
      //     this.checkSearchForm.page += 1;
      //     if (this.checkSearchForm.total < this.checkSearchForm.limit) {
      //       this.noMore = true
      //     }
      //   })
      // }
      // 如果不重置,编辑更改需要后,需要重新加载的情况下,最多只能加载到第一部分数据, 而无法加载剩余行的
      if (this.checkSearchForm.page === 1) {
        this.noMore = false
        this.$api.checkTable.getDirList(data).then(res => {
          this.checkStandardDialog.form.checkList = res.list || [];
          this.checkSearchForm.total = res.list?.length || 0;
          this.checkSearchForm.page += 1;
          if (this.checkSearchForm.total < this.checkSearchForm.limit) {
            this.noMore = true
          }
        })
      } else {
        if (this.noMore) return;
        this.$api.checkTable.getDirList(data).then(res => {
          this.checkStandardDialog.form.checkList.push(...res.list);
          this.checkSearchForm.total = res.list?.length || 0;
          this.checkSearchForm.page += 1;
          if (this.checkSearchForm.total < this.checkSearchForm.limit) {
            this.noMore = true
          }
        })
      }
      // if (this.checkSearchForm.page === 1) {
      //   this.$api.checkTable.getDirList(data).then(res => {
      //     this.checkStandardDialog.form.checkList = res.list || []
      //     this.checkStandardDialog.form.total = res.total
      //     if (this.total <= this.checkSearchForm.limit) {
      //       this.noMore = true
      //     } else {
      //       this.checkSearchForm.page = this.checkSearchForm.page + 1
      //     }
      //   })
      // } else {
      //   if (this.noMore) return
      //   this.$api.checkTable.getDirList(data).then(res => {
      //     if (res.total < this.checkSearchForm.page * this.checkSearchForm.limit) {
      //       this.noMore = true
      //     } else {
      //       this.checkStandardDialog.form.checkList.push(...res.list)
      //       this.checkStandardDialog.form.total = res.total
      //       this.checkSearchForm.page = this.checkSearchForm.page + 1
      //     }
      //   })
      // }
    }, 500),
    // getItemList 这个方法也要改写
    getItemList: _.debounce(function () {
      const data = {
        checklistId: this.standSearchForm.checklistId,
        checklistDirectoryId: this.standSearchForm.checklistDirectoryId,
        pageNum: this.standSearchForm.page,
        pageSize: this.standSearchForm.limit
      }
      if (this.standSearchForm.page === 1) {
        this.noNext = false
        this.$api.checkTable.getItemList(data).then(res => {
          this.checkStandardDialog.form.checkStandardList = res.list || [];
          this.standSearchForm.total = res.list?.length || 0;
          this.standSearchForm.page += 1;
          if (this.standSearchForm.total < this.standSearchForm.limit) {
            this.noNext = true
          }
        })
      } else {
        if (this.noNext) return;
        this.$api.checkTable.getItemList(data).then(res => {
          this.checkStandardDialog.form.checkStandardList.push(...res.list);
          this.standSearchForm.total = res.list?.length || 0;
          this.standSearchForm.page += 1;
          if (this.standSearchForm.total < this.standSearchForm.limit) {
            this.noNext = true
          }
        })
      }
    }, 500),
    // 树结构数据
    getDirectoryTree () {
      return new Promise((resolve, reject) => {
        this.$api.checkStandard.getTreeData().then(res => {
          this.directoryTree = res;
          if (this.selTreeItem.id) {
            this.$nextTick(() => {
              // this.$refs.tree.setCurrentKey(null);
              this.$refs.tree.setCurrentKey(this.selTreeItem.id);
              // 更新当前选中项的相关参数
              this.selTreeItem = this.$refs.tree.getCurrentNode()
            })
          }
          resolve(res)
        })
      })
    },
    searchTreeData () {
      this.treeSearchForm.pageNum = 1;
      this.treeSearchForm.pageSize = 10;
      this.treeSearchForm.currentTotal = 10;
      this.treeData = [];
      this.getTreeData();
    },
    resetTreeData () {
      this.treeSearchForm.pageNum = 1;
      this.treeSearchForm.pageSize = 10;
      this.treeSearchForm.currentTotal = 10;
      this.treeSearchForm.fuzzy = '';
      this.treeData = [];
      this.getTreeData();
    },
    // 某个目录下的列表(这里要重新改一下, 改为分页器)
    getTreeData: _.debounce(function () {
      if (this.treeSearchForm.pageNum === 1) {
        this.scrollMore = false
        this.$api.checkStandard.getTableData({
          checkStandardId: this.treeSearchForm.checkStandardId,
          fuzzy: this.treeSearchForm.fuzzy,
          pageNum: this.treeSearchForm.pageNum,
          pageSize: this.treeSearchForm.pageSize
        }).then(res => {
          this.treeSearchForm.currentTotal = res.list.length;
          this.treeData = res.list.map(item => ({
            ...item,
            selected: false
          }))
          this.treeSearchForm.pageNum++;
          if (this.treeSearchForm.currentTotal < this.treeSearchForm.pageSize) {
            this.scrollMore = true
          }
        })
      } else {
        if (this.scrollMore) return false;
        this.$api.checkStandard.getTableData({
          checkStandardId: this.treeSearchForm.checkStandardId,
          fuzzy: this.treeSearchForm.fuzzy,
          pageNum: this.treeSearchForm.pageNum,
          pageSize: this.treeSearchForm.pageSize
        }).then(res => {
          this.treeSearchForm.currentTotal = res.list.length;
          this.treeData.push(...res.list.map(item => ({
            ...item,
            selected: false
          })));
          this.treeSearchForm.pageNum++;
          if (this.treeSearchForm.currentTotal < this.treeSearchForm.pageSize) {
            this.scrollMore = true
          }
        })
      }
    }, 500),
    handleClick (item) {
      if (this.selCheckItem.id === item.id) {
        this.selCheckItem = {
          id: '',
          checklistId: ''
        }
      } else {
        this.selCheckItem = item
      }
    },
    handleNodeClick (e) {
      if (!this.selTreeItem.id) {
        this.selTreeItem = e;
      } else {
        if (this.selTreeItem.id !== e.id) {
          this.selTreeItem = e;
        } else {
          this.selTreeItem = {
            name: '',
            id: ''
          }
          this.$refs.tree.setCurrentKey(null);
        }
      }
    },
    hideClose (done) {
      this.selCheckItem = {
        id: '',
        checklistId: ''
      };
      this.loading = false;
      done();
      // 检查标准列表的目录id需要为空
      // this.standSearchForm.checklistDirectoryId = ''
    },
    openImport () {
      if (this.selCheckItem.id) {
        // 获取左边树
        this.getDirectoryTree();
        this.importDialog.show = true;
      } else {
        this.$message({
          type: 'warning',
          message: '请选择一个检查项目'
        })
      }
    }
  },
  created () {
    this.$api.checkTable.typeList().then(res => {
      this.option.type = res;
    })
    this.getTableData()
  },
  mounted () {
  }
}
</script>

<style lang="scss" scoped>
.checkStandard {
  width: 100%;
  border-radius: 4px;
  border: 1px solid #E7E7E7;
  box-sizing: border-box;
  .left {
    width: 261px;
    border-right: 1px solid #E7E7E7;
    padding: 16px;
    box-sizing: border-box;
  }
  .right {
    overflow: hidden;
    flex: 1;
    padding: 16px;
    box-sizing: border-box;
  }
}

.item {
  border: 1px solid #E6E6E6;
  cursor: pointer;
  border-radius: 4px;
  box-sizing: border-box;
  margin-bottom: 5px;
  padding: 0 10px;
}

.active {
  background: #F0F4FF;
  border-radius: 4px;
  border: 1px solid #1774FF;
  box-sizing: border-box;
}

::v-deep .el-tree-node__content {
    height: 36px;
    border: 1px solid #fff;
  }
::v-deep .el-tree--highlight-current .el-tree-node.is-current > .el-tree-node__content {
  background: #E9EFFF;
  border-radius: 4px;
  border: 1px solid #8AA6FB;
}
::v-deep .el-tree-node:focus > .el-tree-node__content {
    background-color: #fff;
}
</style>
